import React from 'react'
import './_DotLoader.scss'

export default ({ inlineBlock, className }) => (
  <div
    className={`DotLoader${className ? ` ${className}` : ''}`}
    style={inlineBlock ? { display: 'inline-block' } : null}
  />
)
